import DeliveryNote, {ApiDeliveryNote, DetailDeliveryNoteFilters, DeliveryNoteFilters} from '@/model/DeliveryNote';
import {CombinedApiResponse, doApiRequest, Method, Module} from '..';
import {parseGenericFilters} from '../meta/filters';
import {ApiSortOrder, ApiSortsDerived} from '../meta/odata';

export enum ResourceVerkaufslieferschein {
  Verkaufslieferschein = '/Verkaufslieferschein',
}

export async function getDeliveryNotes(
    filters: DeliveryNoteFilters,
    sorts: ApiSortsDerived<ApiDeliveryNote>,
    limit: number | null = null,
    skip: number = 0,
): Promise<CombinedApiResponse<DeliveryNote[]>> {
  const response = await doApiRequest<ApiDeliveryNote[]>({
    method: Method.Get,
    resource: ResourceVerkaufslieferschein.Verkaufslieferschein,
    module: Module.Verkaufslieferschein,
    filters: parseGenericFilters({...filters}),
    select: new Set(['VerkauflieferscheinNr', 'Datum', 'Uhrzeit', 'ausgeliefert', 'AuftragNr', 'RechnungNr']),
    sorts,
    skip,
    limit,
  });

  return [response.Data.map((p) => DeliveryNote.fromApi(p)), response.CountAll];
}

export async function getDetailDeliveryNote(
    filters: DetailDeliveryNoteFilters,
): Promise<CombinedApiResponse<DeliveryNote | null>> {
  const response = await doApiRequest<ApiDeliveryNote[]>({
    method: Method.Get,
    resource: ResourceVerkaufslieferschein.Verkaufslieferschein,
    module: Module.Verkaufslieferschein,
    filters: parseGenericFilters({...filters}),
    select: new Set([
      'VerkauflieferscheinNr',
      'AuftragNr',
      'RechnungNr',
      'Datum',
      'UhrZeit',
      'Bediener',
      'Gutschrift',
      'Gedruckt',
      'Ausgeliefert',
      'Vertreter',
      'Vertreter2',
      'Kostenstelle',
      'Niederlassung',
      'KundenNr',
      'DebitorKonto',
      'Kundname',
      'RechnungHauptkunde',
      'WiegescheinNr',
      'KundenAuftragNr',
      'Archiv',
      'Dateien',
      'Unterlagen',
    ]),
    expand: {
      ['Positionen']: {
        select: new Set([
          'PosNr',
          'ArtikelNr',
          'ArtikelBezeichnung1',
          'ArtikelBezeichnung2',
          'Menge',
          'Einheit',
        ]),
        sorts: [['PosNr', ApiSortOrder.Asc]],
        expand: {
          ['Preis']: {
            select: new Set(['EinheitsPreis', 'Netto']),
          },
        },
      },
      ['Lieferung']: {
        select: new Set(['GeplantLieferdatum']),
      },
    },
  });

  return response.Data.length ? [DeliveryNote.fromApi(response.Data[0])] : [null];
}
